const getGuideById = state => id => state["guide" + id] || {};
const getStrategyById = state => id => state["strategy" + id] || {};
const getArticleById = state => id => state["article" + id] || {};
const getTopicById = state => id => state["topic" + id] || {};
const getWorkshopById = state => id => state["workshop" + id] || {};
const getWorkshopRegStateById = state => id =>
  state["workshopRegState" + id] || null;
const getTopics = state => () => state["topics"] || {};
const getArticles = state => () => state["articles"] || {};
const assessmentState = state => state.assessmentState || {};
const getWorkshops = state => () => state["workshops"] || {};
const getAssessmentData = state => () => state["assessmentData"] || {};

export default {
  getGuideById,
  getStrategyById,
  getArticleById,
  getTopicById,
  getWorkshopById,
  getWorkshopRegStateById,
  getTopics,
  getArticles,
  assessmentState,
  getWorkshops,
  getAssessmentData
};
